var _circle, _circle2, _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoundQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_267_2681",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.089,
    r: 12,
    fill: "url(#paint0_radial_267_2681)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.089,
    r: 12,
    fill: "#65AAE0",
    fillOpacity: 0.33
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_267_2681)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.089,
    r: 12,
    fill: "#E47005"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9083,
    cy: 9.52413,
    rx: 11.7252,
    ry: 11.2672,
    fill: "#F68E1A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.98761,
    cy: 5.49193,
    rx: 2.15267,
    ry: 4.16794,
    transform: "rotate(42.4505 5.98761 5.49193)",
    fill: "white",
    fillOpacity: 0.33
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4691 15.024C10.3704 14.7867 10.321 14.5033 10.321 14.1737C10.321 13.6728 10.3951 13.2378 10.5432 12.8687C10.6914 12.4995 10.8724 12.1634 11.0864 11.8602C11.3004 11.5438 11.5391 11.2472 11.8025 10.9703C12.0658 10.6803 12.3045 10.3705 12.5185 10.041C12.7325 9.7114 12.9136 9.34228 13.0617 8.93362C13.2099 8.51178 13.284 8.01083 13.284 7.4308C13.284 6.92986 13.1605 6.58051 12.9136 6.38277C12.6831 6.17185 12.3539 6.06639 11.9259 6.06639C11.4979 6.06639 11.1605 6.17185 10.9136 6.38277C10.6831 6.58051 10.5679 6.92986 10.5679 7.4308V8.93362H8V7.56922C8 6.44869 8.32922 5.59181 8.98765 4.99859C9.66255 4.39219 10.6667 4.08899 12 4.08899C13.3333 4.08899 14.3292 4.39219 14.9877 4.99859C15.6626 5.59181 16 6.44869 16 7.56922C16 8.17562 15.9177 8.70292 15.7531 9.15114C15.6049 9.58616 15.4074 9.98164 15.1605 10.3376C14.93 10.6935 14.6749 11.0231 14.3951 11.3263C14.1152 11.6163 13.8519 11.9063 13.6049 12.1963C13.3745 12.4864 13.177 12.7961 13.0123 13.1257C12.8642 13.4553 12.7901 13.831 12.7901 14.2528C12.7901 14.5429 12.823 14.7999 12.8889 15.024H10.4691ZM12.963 15.9929V18.089H10.3457V15.9929H12.963Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_267_2681",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.9313 5.21876) rotate(-26.8869) scale(29.1683 20.1103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#65AAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013E73"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundQuestion);
export default __webpack_public_path__ + "static/media/round-question.0c1bcc12.svg";
export { ForwardRef as ReactComponent };